import React, { memo, useMemo } from 'react';
import { Placement as JiraNavbarAssetsAppSectionPlacement } from '@post-office/placements/jira-navbar-assets-app-section/frontend';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { postOfficeAssetsMenuItemFreeUsersPlacementResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { PlacementFetchProvider } from '@jira/post-office__post-office-provider/src/placement-fetch-provider.tsx';
import { usePlacementPreloadedData } from '@jira/post-office__post-office-provider-preload-placement/src/preload-placement.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import type { DefaultMessagesResponse } from '@post-office/placement-common-v2/types';

export const AssetsMenuItemFreeUsersPlacement: React.MemoExoticComponent<() => React.JSX.Element> =
	memo((): React.JSX.Element => {
		const [preloadedInitialData] = usePlacementPreloadedData(
			postOfficeAssetsMenuItemFreeUsersPlacementResource,
		);
		const memoizedPlacementProps = useMemo(
			() => ({
				// oxlint-disable-next-line typescript/consistent-type-assertions
				preloadedInitialData: preloadedInitialData as DefaultMessagesResponse | undefined,
			}),
			[preloadedInitialData],
		);

		return (
			<UFOSegment name="assets-menu-item-free-users-placement">
				<JSErrorBoundary
					id="assetsMenuItemFreeUsersPlacement"
					teamName="Sequoia"
					fallback="unmount"
				>
					<PlacementFetchProvider resource={postOfficeAssetsMenuItemFreeUsersPlacementResource}>
						<JiraNavbarAssetsAppSectionPlacement
							preloadedInitialData={memoizedPlacementProps.preloadedInitialData}
						/>
					</PlacementFetchProvider>
				</JSErrorBoundary>
			</UFOSegment>
		);
	});
